const doc = [({"da":({"js":({"admin":({"sheet_sizes":({"create_card":({"create_sheet_size":"Opret arkstørrelse"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;